import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import Ornament from "../../../../images/LandingPageImage/Pattern.svg"
import digitalmarketing from "../../../../images/LandingPageImage/industrymarketing.png";
import healthcare from "../../../../images/LandingPageImage/healthcare.png";
import travel from "../../../../images/LandingPageImage/travel.png";
import education from "../../../../images/LandingPageImage/education.png";
import realestate from "../../../../images/LandingPageImage/realestate.png";
import Logistics from "../../../../images/LandingPageImage/logistic.png";
import ecommerce from "../../../../images/LandingPageImage/e-commerce.png";


const tabs = [
    {
        label: "Marketing",
        title: "Marketing",
        desc: "Make Agency Workflows Easy with WhatsApp Chatbots",
        point1: "Organize campaigns, discussions and clients without problems with intelligent WhatsApp chatbots designed with the modern agencies in mind.",
        point2: "Follow-ups to customers are automated.",
        point3: "Send timely messages and updates on a large scale.",
        point4: "Enhance the conversion through the intelligent WhatsApp notifications.",
        image: digitalmarketing,
    },
    {
        label: "Healthcare",
        title: "Healthcare",
        desc: "Enhance Patient contact through Real-time WhatsApp notifications",
        point1: "Make the patient experience better by automation of WhatsApp and notifications.",
        point2: "Send automatic appointment reminders.",
        point3: "Facilitate 24/7 patient services by use of chatbots.",
        point4: "Minimize wait time with instant bot reply.",
        point5: "Best in clinics that require a simplified communication and care delivery process.",
        image: healthcare,
    },
    {
        label: "Travel",
        title: "Travel",
        desc: "Share Travel Sends Instant Updates to WhatsApp",
        point1: "Inform travelers on every step using WhatsApp real-time notifications.",
        point2: "Send booking confirmations in real time.",
        point3: "Make available live flight and schedule updates.",
        point4: "Automate delivery of travel itinerary.",
        point5: "WhatsApp marketing can assist travel companies to earn trust and decrease the number of requests.",
        image: travel,
    },
    {
        label: "Real Estate",
        title: "Real Estate",
        desc: "Transact Property Deals Faster and with WhatsApp Automation.",
        point1: "WhatsApp marketing can be used to reach buyers, lower response time, and organize property communication effectively and immediately.",
        point2: "Automate inquiries and follow-ups of property.",
        point3: "Display real estate ads in real time through WhatsApp.",
        point4: "Real time auto-response to buyer requests.",
        point5: "Obtain and screen good quality property leads.",
        image: realestate,
    },
    {
        label: "Education",
        title: "Education",
        desc: "Improve student communication with WhatsApp automation",
        point1: "Send fee reminders & notices.",
        point2: "Share study materials instantly.",
        point3: "Automate admission queries.",
        image: education,
    },
    {
        label: "Logistics",
        title: "Logistics",
        desc: "Allow Real-Time Communication of Shipment",
        point1: "Post real time shipment tracking.",
        point2: "Send real time delivery notifications.",
        point3: "Automatically respond to order queries.",
        point4: "Enhance customer satisfaction through reporting in time.",
        point5: "An intelligent way to use the bulk message to be responsible by the logistics brands.",
        image: Logistics,
    },
    {
        label: "E-Commerce",
        title: "E-Commerce",
        desc: "Repeat Purchases Automation in WhatsApp",
        point1: "Make one-time buyers loyal customers with personalized WhatsApp campaigns.",
        point2: "Immediately update order and delivery information.",
        point3: "Automate cart abandonments.",
        point4: "Increase repeat purchase through targeted bulk messaging WhatsApp messages.",
        point5: "Excellent in relation to brands that plan on employing WhatsApp marketing to increase revenue through ecommerce.",
        image: ecommerce,
    },
];

export default function Industries() {
    const [selectedTab, setSelectedTab] = useState(tabs[0]);
    const [index, setIndex] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setIndex((prev) => {
                const nextIndex = (prev + 1) % tabs.length;
                setSelectedTab(tabs[nextIndex]);
                return nextIndex;
            });
        }, 8000);

        return () => clearInterval(interval);
    }, []);

    return (
        <section
            className="position-relative py-5 font-inter"
            style={{ background: 'linear-gradient(to bottom right, #02151B, #088757)' }}
        >
            
            <img
                src={Ornament}
                className="position-absolute top-0 start-0 pointer-events-none select-none"
                style={{ width: '224px', height: 'auto', zIndex: 0 }}
                alt="decoration"
            />

            <header className="text-center position-relative" style={{ zIndex: 1 }}>
                <h2 className="display-7 fw-semibold text-white font-bricolage">
                    Designed to Fit All Industries
                </h2>
            </header>

            <div className="container mt-5 position-relative" style={{ zIndex: 1, maxWidth: '960px' }}>
                
                <nav className="mt-4 px-2 px-md-0">
                    <ul className="d-flex align-items-center justify-content-between list-unstyled overflow-auto pb-2 flex-nowrap"
                        style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}>
                        {tabs.map((item, i) => (
                            <motion.li
                                key={item.label}
                                className=" btn cursor-pointer border rounded-pill py-2 px-4 me-2 text-nowrap d-flex align-items-center justify-content-center"
                                style={{ fontSize: '15px', border: '1px solid rgba(255,255,255,0.3)' }}
                                animate={{
                                    backgroundColor: selectedTab.label === item.label ? "#C7EB4F" : "rgba(255,255,255,0.2)",
                                    color: selectedTab.label === item.label ? "#1A2D16" : "#ffffff",
                                }}
                                transition={{ duration: 0.25 }}
                                onClick={() => {
                                    setSelectedTab(item);
                                    setIndex(i);
                                }}
                            >
                                {item.label}
                            </motion.li>
                        ))}
                    </ul>
                </nav>

               
                <div className="row align-items-center mt-5 g-4 px-3 px-md-0">
                    
                    <div className="col-12 col-md-6">
                        <AnimatePresence mode="wait">
                            <motion.div
                                key={selectedTab.label + "-content"}
                                initial={{ opacity: 0, x: -25 }}
                                animate={{ opacity: 1, x: 0 }}
                                exit={{ opacity: 0, x: -25 }}
                                transition={{ duration: 0.3 }}
                                className="p-4 rounded-4"
                                style={{ background: 'linear-gradient(to left, rgba(34, 125, 83, 0), rgba(34, 125, 83, 0.87))' }}
                            >
                                <div className="d-inline-block border border-light bg-white bg-opacity-10 rounded-pill py-1 px-3 mb-3">
                                    <p className="m-0 text-white fw-medium">
                                        {selectedTab.title}
                                    </p>
                                </div>

                                <h3 className="font-bricolage-grotesque mb-3 h4" style={{ color: 'yellowgreen' }}>
                                    {selectedTab.desc}
                                </h3>

                                <ul className="mt-3 text-light ps-4">
                                    {[1, 2, 3, 4, 5].map((num) => {
                                        const pointKey = `point${num}`;
                                        const pointValue = selectedTab[pointKey];

                                       
                                        return pointValue && pointValue.trim() !== "" ? (
                                            <li key={num} className="mb-2">
                                                {pointValue}
                                            </li>
                                        ) : null;
                                    })}
                                </ul>
                            </motion.div>
                        </AnimatePresence>
                    </div>

                  
                    <div className="col-12 col-md-6 text-center">
                        <AnimatePresence mode="wait">
                            <motion.img
                                key={selectedTab.label + "-image"}
                                src={selectedTab.image}
                                alt={selectedTab.label}
                                initial={{ opacity: 0, x: 25 }}
                                animate={{ opacity: 1, x: 0 }}
                                exit={{ opacity: 0, x: 25 }}
                                transition={{ duration: 0.3 }}
                                className="img-fluid rounded-4 object-fit-cover"
                                style={{ maxHeight: '600px', width: '100%' }}
                            />
                        </AnimatePresence>
                    </div>
                </div>
            </div>
        </section>
    );
}
